<template>
    <div>
        <h1>Create an Coupon</h1>

        <form class="mt-4" @submit.prevent="createCoupon">
            <div class="form-group">
                <label>
                    <small class="text-muted">Code</small>
                </label>
                <div class="cow">
                    <input type="text" class="form-control" :placeholder="Code" v-model="code" required autofocus
                        :disabled="loading" />
                    <button type="info" class="btn btn-secondary ld-ext-right mt-3" @click="myFunction()">Get random code</button>
                </div>

            </div>

            <div class="form-group">
                <label>
                    <small class="text-muted">Discount</small>
                </label>
                <input type="number" class="form-control" :placeholder="Discount" v-model.number="discount" step="0.01" required autofocus
                    :disabled="loading" />
            </div>

            <div class="form-group">
                <label>
                    <small class="text-muted">End Date</small>
                </label>
                <input type="text" class="form-control" :placeholder="End_Date" v-model="endDate" required autofocus
                    :disabled="loading" />
            </div>

            <button type="submit" class="btn btn-primary ld-ext-right mt-3" :disabled="loading"
                :class="{ running: loading }">
                {{ loading ? "Creating…" : "Create" }}
                <div class="ld ld-ring ld-spin" />
            </button>
        </form>

        <div class="alert alert-danger mt-4" v-if="!loading && error">
            <p class="mb-0 text-center">
                {{ error }}
            </p>
        </div>
    </div>
</template>
  
  
<script>
import { getError } from "../../../helpers";
import FileInput from "../../FileInput";
import store from "../../../store";
import { mapState } from "vuex";

export default {
    components: {
        "file-input": FileInput,
    },

    data() {
        return {
            code: "",
            discount: "",
            endDate: "",
            loading: false,
            error: "",
        };
    },

    methods: {
        createCoupon() {
            this.loading = true;

            this.$store
                .dispatch("coupons/create", {
                    code: this.code,
                    discount: this.discount,
                    endDate: this.endDate,
                })
                .then(() => {
                    this.$router.push({ name: "coupons" });
                })
                .catch((e) => {
                    this.error = getError(e);
                    this.loading = false;
                });
        },

        myFunction: function () {
            this.code = Math.floor(100000 + Math.random() * 900000);
        }
    },

    computed: {
        ...mapState({

        }),
    },

    async beforeRouteEnter(to, from, next) {
        await store.dispatch("coupons/fetchAll");
        next((vm) => {
            if (to.query.parent) vm.parent_id = to.query.parent;
        });
    },

    meta: {
        title: "Create an Coupon",

        meta: [{ property: "og:title", content: "Create an Coupon / Shayah" }],
    },
};
</script>
  